import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import http from './utils/http';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import pub from './utils/methods';
import "./utils/filter";
import './utils/extension';
import ECharts from 'vue-echarts'

import Grid from '@/components/Grid.vue';
import CharCount from '@/components/CharCount.vue';
import TreeGrid from '@/components/TreeGrid.vue';
import EnumSelect from '@/components/EnumSelect.vue';
import MixGrid from "@/components/MixGrid";
import Currency from "@/components/Currency";
import MathJax from './utils/MathJax'
Vue.use(iView);

Vue.component('Grid', Grid);
Vue.component('CharCount', CharCount);
Vue.component('TreeGrid', TreeGrid);
Vue.component('EnumSelect', EnumSelect);
Vue.component('chart', ECharts)
Vue.component("MixGrid", MixGrid);
Vue.component("Currency", Currency);

Vue.config.productionTip = false;
Vue.config.login_flag = false;

http.beforeRequest = function() {
    //store.commit("showLoading");
};
http.afterRequest = function() {
    store.commit('hideLoading');
};
Vue.prototype.$http = http;
Vue.prototype.$pub = pub;
Vue.prototype.MathJax = MathJax

router.beforeEach((to, from, next) => {
    // set moduel & open name & left menus
    if (to.meta) {
        if (to.meta.module && store.state.currentModule != to.meta.module) {
            store.commit('setCurrentModule', to.meta.module);
            for (const i of store.state.menus) {
                if (i.menu_url == to.meta.module) {
                    store.commit('setLeftMenus', i.children);
                    break;
                }
            }
        }
        if (to.meta.openName) {
            store.commit('setOpenName', to.meta.openName);
        }
    }
    if (to.name != 'Login') {
        if (store.state.token) {
            next();
        } else {
            next({
                name: 'Login',
            });
        }
    } else {
        next();
    }
    if (to.name != 'Main' && to.name != 'Login') {
        let breadCurrent = {
            title: to.meta.title || to.meta.bread[to.meta.bread.length - 1].title,
            url: to.name,
            query: to.query,
            params: to.params,
        };
        if (to.meta.root) {
            store.commit('setBreadList', [breadCurrent]);
            store.commit('setCurrentLeftMenu', to.name);
        } else {
            let hasRepeat = false;
            let breadList = [];
            for (let i = 0; i < store.state.breadList.length; i++) {
                let bread = store.state.breadList[i];
                breadList.push(bread);
                if (bread.url == to.name) {
                    hasRepeat = true;
                    break;
                }
            }
            if (!hasRepeat) {
                breadList.push(breadCurrent);
            }
            store.commit('setBreadList', breadList);
        }
    }
});

let vue = new Vue({
    router,
    store,
    render: h => h(App),
});

http.onApiError = function(data) {
    if (data.code == 202) {
        if (!Vue.config.login_flag) {
            Vue.config.login_flag = true;
            vue.$Message.error({
                content: data.msg,
                onClose: () => {
                    store.commit('logout');
                    router.push({ name: 'Login' });
                    Vue.config.login_flag = false;
                },
            });
        }
        router.push({ name: 'Login' });
    } else {
        vue.$Message.error(data.msg);
    }
};

vue.$Message.createSuccess = function(message = '创建成功') {
    vue.$Message.success(message);
};

vue.$Message.saveSuccess = function() {
    vue.$Message.success('保存成功');
};

vue.$Message.deleteSuccess = function() {
    vue.$Message.success('删除成功');
};

Vue.prototype.$promiseConfirm = function(content, title = '提示', config = {}) {
    return new Promise(resolve => {
        let conf = {
            title: title,
            content: content,
            okText: config.okText || '确定',
            cancelText: config.cancelText || '取消',
            onOk: function() {
                if (config.onOk) {
                    config.onOk();
                } else {
                    resolve(true);
                }
            },
        };
        if (config.onCancel) {
            conf.onCancel = config.onCancel;
        }
        this.$Modal.confirm(conf);
    });
};

Vue.prototype.$promiseAlert = function(content, config = {}) {
    return new Promise(resolve => {
        let title = config.title || '提示';
        let conf = {
            title: title,
            content: content,
            onOk: function() {
                resolve();
            },
        };
        let type = config.type || 'info';
        this.$Modal[type](conf);
    });
};

Vue.filter('tsFormat', function(value, format) {
    if (value === undefined || value === '') return '';
    value = parseInt(value);
    return new Date(value * 1000).format(format);
});

vue.$mount('#app');
